import styled, { css } from "styled-components";

interface MainTemplateStyleProps {
  $nav?: boolean;
  $button?: boolean;
  $subPage?: boolean;
  $backButton?: boolean;
}

export const MainTemplate = styled.div<MainTemplateStyleProps>`
  width: 100vw;
  height: 100vh;
  display: grid;
  grid-template-rows: 56px auto;

  ${(props) =>
    props.$subPage &&
    css`
      background: ${(props) => props.theme.colors.mainBg};
    `}

  ${(props) =>
    props.$nav &&
    css`
      grid-template-rows: 56px auto 70px;
    `}
`;

export const MainContentBox = styled.section<MainTemplateStyleProps>`
  overflow-y: auto;
  overflow-x: hidden;

  ${(props) =>
    props.$button &&
    css`
      display: grid;
      grid-template-rows: auto 88px;
    `}
`;

export const MainButtonBox = styled.div<MainTemplateStyleProps>`
  padding: 16px;

  ${(props) =>
    props.$backButton &&
    css`
      gap: 10px;
      display: grid;
      grid-template-columns: 110px auto;
    `}
`;
